import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[twitterShare]'
})
export class TwitterShareDirective {
  @Input() shareText: string;
  constructor() { }

  @HostListener('click')
  onClick() {
      const encodedShareText = encodeURIComponent(this.shareText);
      const encodedShareUrl = encodeURIComponent(window.location.href);
      const twitterShareUrl = `https://twitter.com/intent/tweet?text=${encodedShareText}&url=${encodedShareUrl}`;
      window.open(twitterShareUrl, '_blank');
    
  }
}
